import { formatDate } from "../../../utility-functions";
import Button from "../../design/Button";
import colors from "../../design/colors";
import GModal from "../../design/components/GModal";

const RevokeDeprecateApiKeyConfirmationModal = ({
  mode,
  visible,
  onClose,
  onContinue,
  apiKeyName,
  isLoading,
}) => {
  let deprecationDate = new Date();
  deprecationDate.setDate(deprecationDate.getDate() + 15);

  return (
    <GModal
      heading={mode === "revoke" ? "Revoke API key" : "Deprecate API key"}
      visible={visible}
      closeModal={onClose}
      noScrollbar={true}
      bottomButtons={[
        <Button
          buttonText="Cancel"
          onClick={onClose}
          variant="outlined"
          hierarchy="white"
        />,
        <Button
          buttonText={mode === "revoke" ? "Revoke key" : "Deprecate key"}
          onClick={() => onContinue(apiKeyName)}
          variant={mode === "revoke" ? "contained" : "outlined"}
          hierarchy="red"
          isLoading={isLoading}
          {...(mode === "deprecate"
            ? {
                buttonStyle: {
                  backgroundColor: colors.ic_white,
                  color: colors.cred_600,
                  border: `1px solid ${colors.nc_gray_300}`,
                },
              }
            : {})}
        />,
      ]}
      modalStyle={{ width: "440px" }}
      body={
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <p
            className="regular-font nc-gray-900 t7"
            style={{ lineHeight: "180%" }}
          >
            Are you sure you want to {mode?.toLowerCase()}{" "}
            <span className="medium-font">{apiKeyName}</span>?
          </p>
          {mode === "revoke" ? (
            <p
              className="regular-font nc-gray-900 t7"
              style={{ lineHeight: "180%" }}
            >
              This action is permanent, and any systems using this key will lose
              access immediately.
            </p>
          ) : (
            <p
              className="regular-font nc-gray-900 t7"
              style={{ lineHeight: "180%" }}
            >
              This key will continue to work for 15 days and will automatically
              stop working on {formatDate(deprecationDate)}.
            </p>
          )}
        </div>
      }
    />
  );
};

export default RevokeDeprecateApiKeyConfirmationModal;
